import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SalesforceApiService } from '../../../../services/api';
import { CommonModule } from '@angular/common';
import { SiModalModule } from '../../../si-modal';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-sales-force-account-list',
    templateUrl: './sales-force-account-list.component.html',
    styleUrls: ['./../../export.component.scss'],
    imports: [CommonModule, FormsModule, SiModalModule,
      MatFormFieldModule, ReactiveFormsModule,
      MatButtonModule, MatInputModule
    ],
    standalone: true
})
export class SalesForceAccountListComponent implements OnInit {
    isSelectAccount: boolean = false;
    contacts:any = [];
    leadOwners = [];
    accountsData = [];
    filterAccount = new FormControl('');
    selectedAccount = null;
    isLoading: boolean = false;
    isDisplayNoAccountMessage: boolean = false;

    constructor(
        private salesforceApiService: SalesforceApiService,
        private readonly matDialogRef: MatDialogRef<SalesForceAccountListComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
    ) {
        this.contacts = this.data['contacts'];
        this.leadOwners = this.data['leadOwners'];
        this.isSelectAccount = this.data['isSelectAccount'];
    }

    ngOnInit(): void {
        if (this.isSelectAccount) {
            this.isDisplayNoAccountMessage = true;
            //const companyNames = this.contacts.map((contact: any) => contact.companyName);
            this.getAccounts(this.contacts[0].companyName, this.contacts[0].primaryDomain);
        }
        this.filterAccount.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged()
        ).subscribe((value) => {
            this.selectedAccount = null;
            this.isDisplayNoAccountMessage = true;
            this.getAccounts(value)
        })
    }

    getAccounts(companyName, primaryDomain = null) {
        this.isLoading = true;
        this.accountsData = [];
        const requestBody = {
            "companies": [
                {
                    "domain": primaryDomain,
                    "name": companyName
                }
            ]
            // "domains": null,
            // "names": companyNames
        }
        this.salesforceApiService.getAccounts(requestBody).subscribe((res: any) => {
            this.isLoading = false;
            this.accountsData = res.results;
            this.accountsData.forEach((account) => {
                const leadOwner = this.leadOwners.find((leadOwner) => leadOwner.id == account.owner_id);
                if (leadOwner) {
                    account.ownerName = leadOwner.name;
                }
            });
        }, () => this.isLoading = false);
    }

    onClose(res?) {
        this.matDialogRef.close(res);
    }

    onSelectAccount(account) {
        this.onClose({
            success: true,
            account: account,
            contact: this.contacts
        });
    }
}
